import { Icon, type IconName } from '../icon/icon' // Adjust the import path as needed
import { Link } from '../internal-link/Internal-link'
import { Link as RemixLink } from 'react-router'

export const IconButton = ({
	text,
	icon,
	to,
	external = false,
}: {
	text: string
	icon: IconName
	to: string
	external?: boolean
}) => {
	const LinkComponent = external ? RemixLink : Link

	return (
		<LinkComponent
			to={to}
			className="group relative inline-flex items-center gap-3 overflow-hidden rounded-full border border-secondary bg-transparent px-8 py-3 transition-all duration-300 hover:border-secondary/50 hover:bg-secondary/20 hover:pl-10 hover:pr-9 hover:shadow-[0_0_15px_rgba(var(--color-secondary-rgb),0.4)]"
		>
			<span className="absolute left-0 flex h-full w-10 translate-x-[-100%] items-center justify-center bg-secondary/20 transition-all duration-300 ease-out group-hover:translate-x-0">
				<Icon name={icon} className="text-secondary" />
			</span>
			<span className="relative z-10 flex items-center font-medium tracking-wide transition-transform duration-300 group-hover:translate-x-2">
				{text}
				<Icon
					name="arrow-right"
					className="ml-2 transition-all duration-300 group-hover:translate-x-1"
					size="sm"
				/>
			</span>
		</LinkComponent>
	)
}
